<template>
  <div class="tile is-vertical">
    <div class="tile is-parent">
      <div class="tile is-child is-centered">
        <h5 class="title is-5">
          Number of attempts: {{ attemptData.numberOfAttempts }}
        </h5>
      </div>
    </div>
    <fragment v-if="attemptData.numberOfAttempts">
      <div
        v-for="(step, stepIndex) in attemptData.stepsData"
        :key="stepIndex"
        class="tile is-vertical"
      >
        <div class="tile is-parent">
          <div class="tile is-child">
            <div class="media">
              <h4 class="title is-5">
                Step {{ stepIndex + 1 }} : {{ step.name }}
              </h4>
              <div class="media-right">
                <b-taglist attached>
                  <b-tag type="is-dark">type</b-tag>
                  <b-tag type="is-info">
                    {{ step.type }}
                  </b-tag>
                </b-taglist>
              </div>
            </div>
            <b-progress
              format="percent"
              :precision="2"
              show-value
              :value="step.completedPercent"
            >
              completed by: {{ step.completed }}/{{ step.total }} ({{
                step.completedPercent.toFixed(2)
              }})
            </b-progress>
          </div>
        </div>
        <div v-if="step.type == 'test'" class="tile is-vertical">
          <div class="tile is-parent">
            <div class="tile is-child">
              <b-progress
                format="percent"
                :precision="2"
                show-value
                :value="step.completionPercent"
              >
                completion percent:
                {{ step.overallCompletedQuestions }}/{{
                  step.questionDetails.length * step.stepDetails.length
                }}
                ({{ step.completedPercent.toFixed(2) }})
              </b-progress>
            </div>
          </div>
          <div class="tile is-parent">
            <div
              v-for="questionDetail in step.questionDetails"
              :key="questionDetail.name"
              class="tile is-child"
            >
              <p
                class="subtitle is-7 detailed-analytics__results__question-name"
              >
                {{ questionDetail.name }}
              </p>
              <div class="media">
                <div class="media-content">
                  <p class="subtitle is-7">
                    completed
                  </p>
                  <p class="title is-6">
                    {{ questionDetail.totalCompleted }}/
                    {{ step.stepDetails.length }}
                  </p>
                </div>
              </div>
              <div class="media">
                <div class="media-content">
                  <p class="subtitle is-7">
                    firstAttemptCorrect
                  </p>
                  <p class="title is-6">
                    {{ questionDetail.totalFirstAttemptCorrects }}/
                    {{ questionDetail.totalCompleted }}
                  </p>
                </div>
              </div>
              <div class="media">
                <div class="media-content">
                  <p class="subtitle is-7">
                    AverageNumberOfHops
                  </p>
                  <p class="title is-6">
                    {{
                      (
                        questionDetail.totalNumberOfHops /
                        questionDetail.totalCompleted
                      ).toFixed(2)
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child">
            <hr />
          </div>
        </div>
      </div>
    </fragment>
  </div>
</template>

<script>
export default {
  props: {
    conceptAttempts: {
      required: true,
      type: Array
    },
    versionedConcept: {
      required: true,
      type: Object
    }
  },
  computed: {
    attemptData() {
      const numberOfAttempts = this.conceptAttempts.length;
      const stepsData = [];

      if (!this.conceptAttempts.length) {
        return {
          numberOfAttempts: 0,
          stepsData: []
        };
      }

      this.versionedConcept.steps.forEach((step, stepIndex) => {
        const stepDetails = this.conceptAttempts.map(attempt =>
          this.extractStepData(step, attempt.progress[stepIndex])
        );
        const total = stepDetails.length;
        const completed = stepDetails.filter(v => v.completed).length;
        const completedPercent = this.toPercent(completed, total);

        stepsData.push({
          name: step.name,
          type: step.type,
          total,
          completed,
          completedPercent,
          ...(step.type == 'test'
            ? this.extraTestDetails(step, stepDetails)
            : {}),
          stepDetails
        });
      });

      return {
        numberOfAttempts,
        stepsData
      };
    }
  },
  methods: {
    toPercent(completed, total) {
      return (completed * 100) / total;
    },
    extractStepData(step, stepProgress) {
      if (step.type == 'video') {
        return {
          completed: stepProgress.completed
        };
      } else {
        const questionDetails = step.questions.map((question, questionIndex) =>
          this.extractQuestionData(
            question,
            stepProgress.questions[questionIndex]
          )
        );
        return {
          completed: questionDetails.every(v => v.completed),
          completedQuestions: questionDetails.filter(v => v.completed).length,
          questionDetails
        };
      }
    },
    extractQuestionData(question, questionProgress) {
      return {
        completed: questionProgress.completed,
        numberOfHops: questionProgress.numberOfHops || 0,
        firstAttemptCorrect: questionProgress.numberOfHops == 1
      };
    },
    extraTestDetails(test, attemptsQuestionsData) {
      const overallCompletedQuestions = attemptsQuestionsData.reduce(
        (sum, questionData) => sum + questionData.completedQuestions,
        0
      );
      const completionPercent = this.toPercent(
        overallCompletedQuestions,
        test.questions.length * attemptsQuestionsData.length
      );
      const questionDetails = test.questions.map((question, questionIndex) => {
        let totalCompleted = 0,
          totalNumberOfHops = 0,
          totalFirstAttemptCorrects = 0;
        attemptsQuestionsData.forEach(questionsData => {
          const questionData = questionsData.questionDetails[questionIndex];
          if (questionData.completed) {
            totalCompleted++;
            if (questionData.firstAttemptCorrect) totalFirstAttemptCorrects++;
            totalNumberOfHops = totalNumberOfHops + questionData.numberOfHops;
          }
        });
        return {
          name: question.flowDefinition.prompts.start.message,
          totalCompleted,
          totalNumberOfHops,
          totalFirstAttemptCorrects
        };
      });

      return {
        overallCompletedQuestions,
        completionPercent,
        questionDetails
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.detailed-analytics {
  &__results {
    &__question-name {
      overflow: hidden;
      height: 3rem;
    }
  }
}
</style>
